export const css = {
	root: '_28kJAkW5',
	buffer: '_8DAPbG82',
	bar: '_2mA70Tqq',
	primary: '_8VpjCchW',
	progress: '_3x7eRjbr',
	inner: '_38WFGIiZ',
	' _key': 'apic-theme/apic/dojo/loading-indicator'
};

export default css;
